<template>
  <v-card class="step-card">
    <h2>{{ $t(`registration.thirdStep.title`) }}</h2>

    <div v-if="!exportCompleted">
      <p v-html="$t(`registration.thirdStep.description`)"></p>
      <div class="third-step-buttons">
        <v-btn class="custom-export-button" @click="completeExport">
          {{ $t(`registration.thirdStep.nextBtn`) }}
        </v-btn>

        <!--        <v-btn class="skip-button" outlined @click="skipExport">-->
        <!--          {{ $t(`registration.thirdStep.skip`) }}-->
        <!--        </v-btn>-->
      </div>
    </div>

    <div v-else>
      <v-expansion-panels multiple>
        <v-expansion-panel v-for="child in childrenList" :key="child.iin">
          <v-expansion-panel-header>
            {{ child.surname }} {{ child.full_name }} {{ child.patronymic }}
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <div class="child-info">
              <div>{{ child.school_name }}</div>
              <div>{{ child.class || "" }}</div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-btn color="#635dff" @click="handleContinue" class="save-btn">
        <span>{{ $t(`registration.thirdStep.toProfileBtn`) }}</span>
      </v-btn>
    </div>

    <ProgressCircular v-if="isLoading" />
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ProgressCircular from "@/components/custom/ProgressCircular.vue";
import { showToast } from "@/utils/toast";
import Cookies from "js-cookie";
export default {
  components: { ProgressCircular },
  data() {
    return {
      isLoading: false,
      exportCompleted: false,
    };
  },
  computed: {
    ...mapGetters("exportChild", ["childrenList"]),
  },
  methods: {
    ...mapActions({
      fetchExportChild: "exportChild/loadExportChild",
    }),
    handleContinue() {
      this.exportCompleted = true;
      Cookies.set("first_entry", "false");
      this.$router.push("/profile");
    },
    async loadPageData() {
      this.isLoading = true;
      try {
        await this.fetchExportChild().then((res) => {
          if (Array.isArray(res)) {
            this.exportCompleted = true;
            return;
          }
          if (res.status === 0) {
            showToast(this, {
              text: this.$t(`toastText.wentWrong`),
              status: "error",
              duration: 3000,
            });
          } else if (res.status === 1) {
            showToast(this, {
              text: this.$t(`toastText.sendSMS`),
              status: "success",
              duration: 8000,
            });
          }
        });
      } catch (error) {
        showToast(this, {
          text: `${this.$t(`toastText.errorData`)}: ${error}`,
          status: "error",
          duration: 3000,
        });
      } finally {
        this.isLoading = false;
      }
    },
    completeExport() {
      this.loadPageData();
      // this.exportCompleted = true;
    },
    skipExport() {
      // this.exportCompleted = true;
      // this.$router.push("/profile");
    },
  },
};
</script>

<style scoped>
.v-expansion-panels {
  margin-bottom: 20px;
}
.v-expansion-panels,
.v-expansion-panel--active {
  border-radius: 21px !important;
}
.step-card {
  padding: 20px;
  text-align: center;
}
.step-card h2 {
  font-family: "Montserrat", sans-serif;
}
.custom-export-button {
  background-color: #174ae6 !important;
  font-size: 14px;
  font-weight: bold;
  text-transform: none;
  border-radius: 14px;
  height: 42px !important;
  color: white !important;
  letter-spacing: unset;
  width: 100%;
  padding: 0 24px;
}
.skip-button {
  margin-top: 15px;
  font-size: 14px;
}
.third-step-buttons {
  width: 100%;
  display: flex;
  flex-direction: column;
  max-width: 236px;
  margin: 0 auto;
}
.custom-button:hover {
  background-color: #0f3bc4 !important;
}
.save-btn {
  font-size: 16px;
  font-weight: bold;
  text-transform: none;
  border-radius: 18px;
  display: flex;
  margin: 0 auto;
  height: 50px !important;
  color: white !important;
}
.save-btn:hover {
  background-color: #5148d8 !important;
}
</style>
